module.exports = __webpack_public_path__ + "static/media/test-knife.d1bad894.jpg";